var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8036 27.4183C23.4872 27.4183 28.9054 21.9789 28.9054 15.269C28.9054 8.55907 23.4872 3.11963 16.8036 3.11963C10.1199 3.11963 4.70166 8.55907 4.70166 15.269C4.70166 21.9789 10.1199 27.4183 16.8036 27.4183Z",
    fill: "#9660EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8034 27.8718C9.88125 27.8718 4.25 22.2185 4.25 15.2692C4.25 8.31984 9.88125 2.6665 16.8034 2.6665C23.7256 2.6665 29.3569 8.31984 29.3569 15.2692C29.3569 22.2185 23.7256 27.8718 16.8034 27.8718ZM16.8034 3.57318C10.3806 3.57318 5.15312 8.82117 5.15312 15.2692C5.15312 21.7172 10.3806 26.9652 16.8034 26.9652C23.2263 26.9652 28.4537 21.7172 28.4537 15.2692C28.4537 8.82117 23.2263 3.57318 16.8034 3.57318Z",
    fill: "#D57BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7776 22.3817C16.2942 22.3817 15.8533 22.1363 15.6089 21.747L10.8967 15.0643C10.4133 14.3817 10.6045 13.5017 11.2367 13.0163C11.9167 12.531 12.7933 12.723 13.2767 13.3577L16.5811 17.9923L20.6664 9.35766C21.0064 8.627 21.8829 8.33365 22.6108 8.67498C23.3386 9.01631 23.6308 9.89632 23.2908 10.627L18.1376 21.555C17.8933 22.0403 17.4576 22.3337 16.9211 22.387H16.7776V22.3817Z",
    fill: "#E4F5F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked_icon.6e47b59010e97513934bf266e3ba9557.svg";
export { ForwardRef as ReactComponent };